import { 
  Instagram,
  Linkedin,
  MessageCircle,
} from "lucide-react";
import logo from "@/assets/digital_consulting_logo.webp";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-4">
            <img src={logo} alt="Digital Consulting" className="h-40 w-auto opacity-80" />
            <p className="text-foreground/80 text-sm">
              Producción audiovisual y marketing digital.
            </p>
          </div>
          
          {/* Social */}
          <div className="flex items-center gap-4">
            <a 
              href="https://www.instagram.com/digitalconsultingcr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:text-accent transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a 
              href="https://www.linkedin.com/company/digitalconsultingcr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:text-accent transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a 
              href="https://wa.me/50670473873" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:text-accent transition-colors"
              aria-label="WhatsApp"
            >
              <MessageCircle className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-border/30 text-center">
          <p className="text-foreground/70 text-xs">
            © {currentYear} Digital Consulting
          </p>
        </div>
      </div>
    </footer>
  );
};
